import React from 'react';
import { Navigate } from 'react-router-dom';

interface PrivateRouteProps {
    children: React.ReactNode;
}

export default function PrivateRoute({ children }: PrivateRouteProps): React.ReactElement {
    const isAuthenticated = document.cookie.includes('authToken');
    return isAuthenticated ? <>{children}</> : <Navigate to="/" />;
}